/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext, useState } from 'react';
import { useTranslation } from '@scuf/localization';
import {
  IPortfolioEnergyData,
  IPortfolioTableColumns
} from '../../IPortfolioEnergyViewDetails';
import { getColumnDetails } from './TableColumnRenderUtils';
import {
  getPortfolioEnergyData,
  getPortfolioEnergyDataWithPercentage
} from '../../../../../shared/Utils/PortfolioEnergy/PortfolioEnergyVDUtils';
import { DataTable } from '@scuf/datatable';
import {
  EnergyViewDetailsAllUtilitiesFields,
  PreferredUnit
} from '../../../../../shared/Utils/Constants';
import { ApiContext } from '../../../../../../context/ApiContext';
import { conversionCheck } from '../../../../../shared/Utils/Utils';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';

interface ITotalEmissionsSavingsByMeterDetailComponentProps {
  data: IPortfolioEnergyData;
  tabName?: string;
}
export const PortfolioEnergyBottomTableWidget = (
  props: ITotalEmissionsSavingsByMeterDetailComponentProps
) => {
  const [t] = useTranslation();
  const { data, tabName } = props;
  const apiContext = useContext(ApiContext);
  const {
    onPortfolioSiteClick,
    preferredEuiUnit,
    userPreferedUnit
  } = apiContext;
  let fromUnit: string;
  // if (true) {
  //   fromUnit = userPreferedUnit as any;
  // } else {
  //   fromUnit = energyMeasurementUnit;
  // }
  fromUnit =
    data.sourceType && data.sourceType.toLowerCase() === 'water'
      ? PreferredUnit.Water
      : userPreferedUnit === 'megajoule'
      ? userPreferedUnit
      : tabName == 'gas'
      ? apiContext.toggleEnableKwhGas
        ? PreferredUnit.Electricity
        : PreferredUnit.Gas
      : (PreferredUnit.Electricity as any);
  const [fieldSortOrder, setFieldSortOrder] = useState<number>(-1);
  const [sortFieldName, setSortFieldName] = useState<string>(
    EnergyViewDetailsAllUtilitiesFields.actualConsup
  );
  const conversionType = conversionCheck(data.sourceType);
  let originalUnit = data.energyMeasurementUnit;
  const columnDetails = getColumnDetails(
    t,
    tabName,
    conversionType,
    originalUnit,
    fromUnit,
    apiContext.showChangeWhenData,
    data.subscriptionType
  );
  const onSiteclick = (siteId: string) => {
    if (siteId) {
      if (onPortfolioSiteClick) {
        onPortfolioSiteClick(siteId);
      }
    }
  };

  const { convertedTableData } = getPortfolioEnergyDataWithPercentage(
    data,
    onSiteclick,
    fromUnit,
    preferredEuiUnit || '',
    apiContext.showChangeWhenData
  );
  return (
    <div className="emaas-Metersaving-details-head">
      <div
        className={
          tabName == 'gas'
            ? 'Savings-Datatable breakdownBySite-gas-table'
            : 'Savings-Datatable'
        }
      >
        <DataTable
          className="nonflat-table Savingtable"
          data={convertedTableData}
          onSort={({ sortField, sortOrder }) => {
            setFieldSortOrder(sortOrder as number);
            setSortFieldName(sortField);
          }}
          sortField={sortFieldName}
          sortOrder={fieldSortOrder}
        >
          {columnDetails.map((column: IPortfolioTableColumns) => {
            return (
              <DataTable.Column
                key={column.field}
                className={column.className}
                field={column.field}
                header={column.header}
                sortable={column.sortable}
                renderer={column.render}
                initialWidth={column.initialWidth}
              />
            );
          })}
        </DataTable>
      </div>
    </div>
  );
};
export default PortfolioEnergyBottomTableWidget;
